import { roleGuarded } from '@/components/shell/RoleState';
import { AccountTab } from '@/features/settings/AccountTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/account')({
  staticData: { roles: ['owner'] },
  component: roleGuarded(AccountTab),
});
